import $ from 'jquery';

// First import of vendor.ts: the plugins imported after it read this global, and jquery-migrate reads these flags, as they evaluate.
window.$ = $;
window.jQuery = $;
$.migrateMute = true;
$.migrateTrace = false;
